import * as fromDatatype from '../datatype-library/index';

export interface bl_dgmkt_sales_tracking_report_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  campaign_hdr_guid: fromDatatype.GuidDataFieldInterface;
  campaign_event_guid: fromDatatype.GuidDataFieldInterface;
  segment_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  store_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  generic_doc_type: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_hdr_guid: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  endpoint_id: fromDatatype.VarcharDatatypeInterface;
  customer_info: fromDatatype.JsonDatatypeInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_info: fromDatatype.JsonDatatypeInterface;
  date_from: fromDatatype.TimestampTzDatatypeInterface;
  date_to: fromDatatype.TimestampTzDatatypeInterface;

  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  channel_type: fromDatatype.VarcharDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
}

export class bl_dgmkt_sales_tracking_report_RowClass
  implements bl_dgmkt_sales_tracking_report_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  campaign_hdr_guid: fromDatatype.GuidDataFieldInterface;
  campaign_event_guid: fromDatatype.GuidDataFieldInterface;
  segment_hdr_guid: fromDatatype.GuidDataFieldInterface;
  segment_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  company_guid: fromDatatype.GuidDataFieldInterface;
  branch_guid: fromDatatype.GuidDataFieldInterface;
  store_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  generic_doc_type: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_hdr_guid: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  endpoint_id: fromDatatype.VarcharDatatypeInterface;
  customer_info: fromDatatype.JsonDatatypeInterface;
  item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  item_info: fromDatatype.JsonDatatypeInterface;
  date_from: fromDatatype.TimestampTzDatatypeInterface;
  date_to: fromDatatype.TimestampTzDatatypeInterface;

  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  channel_type: fromDatatype.VarcharDatatypeInterface;
  amount_txn: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
}
